import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './rem'
import less from 'less'
Vue.use(less)
Vue.config.productionTip = false


//引入web端和h5端插件
import '@/plugins'

/*******   web端和h5端公共的插件   ***********/
//二维码
import vueQr from 'vue-qr'
Vue.component('vue-qrcode', vueQr)
//路由缓存
// import Navigation from "vue-navigation";
// Vue.use(Navigation, { router });
// EventBus事件总线
Vue.prototype.eventBus = new Vue();

//自定义指令
import input from './directive/input'
Vue.directive('input',input)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
